/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MeterValuesSnapshot } from "./MeterValuesSnapshot";
import {
    MeterValuesSnapshotFromJSON,
    MeterValuesSnapshotFromJSONTyped,
    MeterValuesSnapshotToJSON,
} from "./MeterValuesSnapshot";

/**
 *
 * @export
 * @interface PowerMeterSnapshot
 */
export interface PowerMeterSnapshot {
    /**
     *
     * @type {string}
     * @memberof PowerMeterSnapshot
     */
    uniqueId?: string;
    /**
     *
     * @type {string}
     * @memberof PowerMeterSnapshot
     */
    coreConnectionStatus?: string;
    /**
     *
     * @type {MeterValuesSnapshot}
     * @memberof PowerMeterSnapshot
     */
    meterValues?: MeterValuesSnapshot;
}

/**
 * Check if a given object implements the PowerMeterSnapshot interface.
 */
export function instanceOfPowerMeterSnapshot(
    value: object,
): value is PowerMeterSnapshot {
    return true;
}

export function PowerMeterSnapshotFromJSON(json: any): PowerMeterSnapshot {
    return PowerMeterSnapshotFromJSONTyped(json, false);
}

export function PowerMeterSnapshotFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PowerMeterSnapshot {
    if (json == null) {
        return json;
    }
    return {
        uniqueId: json["uniqueId"] == null ? undefined : json["uniqueId"],
        coreConnectionStatus:
            json["coreConnectionStatus"] == null
                ? undefined
                : json["coreConnectionStatus"],
        meterValues:
            json["meterValues"] == null
                ? undefined
                : MeterValuesSnapshotFromJSON(json["meterValues"]),
    };
}

export function PowerMeterSnapshotToJSON(
    value?: PowerMeterSnapshot | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        uniqueId: value["uniqueId"],
        coreConnectionStatus: value["coreConnectionStatus"],
        meterValues: MeterValuesSnapshotToJSON(value["meterValues"]),
    };
}
